// src/utils/auth.js
let currentUser = null;      // { user_id, emp_id, bo_id, roles }
let currentPermissions = {}; // { screen_name: [permission1, permission2] }

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCurrentUser = async () => {
  console.log("fetchCurrentUser", BASE_URL);
  try {
    const res = await fetch(`${BASE_URL}/api/me`, {
      credentials: "include", // send HttpOnly cookie
    });
    console.log("Fetch current user response:", res);
    if (!res.ok) throw new Error("Not authenticated");
    const data = await res.json();
    currentUser = data.user;
    currentPermissions = data.permissions;
    return data.user;
  } catch (err) {
    currentUser = null;
    currentPermissions = {};
    console.error("Failed to fetch current user:", err);
    return null;
  }
};

// User getters
export const getUserId = () => currentUser?.user_id || null;
export const getEmpId = () => currentUser?.emp_id || null;
export const getBoId = () => currentUser?.bo_id || null;
export const getUserRole = () => currentUser?.roles || [];
export const hasRole = (roleName) => getUserRole().includes(roleName);

// Permissions
export const getUserPermissions = () => currentPermissions;

export const hasPermission = (screen, permissionType) => {
  if (!currentPermissions) return false;
  const perms = currentPermissions[screen];
  if (!perms) return false;
  return perms.some(
    (p) => p.toLowerCase() === permissionType.toLowerCase()
  );
};